import { createRowActions, DataTable, type DataTableVariant } from "@msuite/ui/table";
import type React from "react";
import { loadCarriersTableColumns } from "@/components/stock";
import { useLoadCarriers } from "@/hooks/use-load-carriers";
import { RowActions } from "./row-actions";

/** Props Interface */
interface LoadCarriersTableProps {
	menu?: React.ReactNode;
	variant?: DataTableVariant;
}

export function LoadCarriersTable({ menu = null, variant = "table" }: LoadCarriersTableProps) {
	/** Hooks */
	const { loadCarriers, isLoading, queryKey, refetch } = useLoadCarriers();

	/** Render */
	return (
		<DataTable
			data={loadCarriers}
			columns={[...loadCarriersTableColumns, createRowActions(RowActions)]}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			menu={menu}
			persistenceKey="data-load-carriers-table"
			initialPinningState={{
				start: [],
				end: ["stockBalance", "warningStockBalance", "minimumStockBalance"],
			}}
			variant={variant}
		/>
	);
}
